import React, { useCallback } from 'react';
import { Button, ButtonProps } from '@mui/material';
import { useTranslate } from 'hooks/use-translate';
import { useIsBelowMd } from 'hooks/use-is-below-md';
import { useEffectError } from 'hooks';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { apiUserPatientProfile, createBackdoorLink } from 'services/user-patient-profile';
import { isMutationFulfilled } from 'utils/rtk-query';

const MINUTES = 60 * 24 * 7;
interface Props extends ButtonProps {
  userPatientProfileID: string;
}

export const ButtonBackDoor: React.FC<React.PropsWithChildren<Props>> = ({
  userPatientProfileID,
  ...rest
}) => {
  const { t } = useTranslate();
  // Phase F3 (F3-03, D-69): below md the card's action bar has no room for labels; the icon keeps the title (F1's add-task pattern).
  const isBelowMd = useIsBelowMd();

  const [makeBackDoor, { isLoading, error }] =
    apiUserPatientProfile.useMakePatientBackDoorMutation();
  useEffectError(error);

  const onMake = useCallback(async () => {
    const res = await makeBackDoor({ userPatientProfileID, minutes: MINUTES });

    if (isMutationFulfilled(res) && res.data) {
      window.open(
        createBackdoorLink({
          userPatientProfileID: res.data.userPatientProfileID,
          secret: res.data.secret,
        }),
        '_blank',
      );
    }
  }, [userPatientProfileID, makeBackDoor]);

  return (
    <Button
      variant={'contained'}
      color={'primary'}
      startIcon={isBelowMd ? undefined : <PhoneIphoneIcon />}
      title={t('back-door')}
      aria-label={t('back-door')}
      disabled={isLoading}
      onClick={onMake}
      {...rest}
    >
      {isBelowMd ? <PhoneIphoneIcon /> : t('back-door')}
    </Button>
  );
};
